export default __webpack_public_path__ + "static/media/facebook.f4950fbf.svg";